/**
 * 分支合并模态框常量定义
 * 集中管理所有魔术字符串和配置常量
 */
import { BASE_API_PATH } from '@config/constant';
// ============================================================================
// Schema 相关常量
// ============================================================================
/**
 * AI 项目信息的 Schema Key
 * 用于识别 AI 项目类型的合并项，需要特殊处理
 */
export const AI_PROJECT_INFO_SCHEMA_KEY = '_wuji_xy:ai_project_info';
/**
 * 需要进行 URL 编解码的字段列表
 * 这些字段在 YAML 转换前需要 decode，转换后需要 encode
 */
export const ENCODE_DECODE_FIELDS = ['bodyScript', 'headScript'];
// ============================================================================
// API 相关常量
// ============================================================================
/**
 * 分支操作 API 基础路径
 */
export const BRANCH_API_BASE_URL = `${BASE_API_PATH}/xy/design/branch`;
/**
 * 分支操作超时时间（毫秒）
 */
export const BRANCH_API_TIMEOUT = 60 * 1000;
// ============================================================================
// 合并项状态枚举
// ============================================================================
/**
 * 合并项状态枚举
 * 用于标识合并项在侧边栏中的分类和显示状态
 */
export var MergeItemStatus;
(function (MergeItemStatus) {
    /** 未解决的冲突 - 需要用户手动解决 */
    MergeItemStatus["CONFLICT_UNRESOLVED"] = "conflict_unresolved";
    /** 已解决的冲突 - 用户已完成冲突解决 */
    MergeItemStatus["CONFLICT_RESOLVED"] = "conflict_resolved";
    /** 自动合并 - 无冲突，系统自动合并完成 */
    MergeItemStatus["AUTO_MERGED"] = "auto_merged";
})(MergeItemStatus || (MergeItemStatus = {}));
/**
 * 旧版 SectionType 到新版 MergeItemStatus 的映射
 * 用于兼容旧代码
 * @deprecated 请使用 MergeItemStatus
 */
export const SECTION_TYPE_TO_STATUS = {
    unresolved: MergeItemStatus.CONFLICT_UNRESOLVED,
    resolved: MergeItemStatus.CONFLICT_RESOLVED,
    merged: MergeItemStatus.AUTO_MERGED,
};
/**
 * 新版 MergeItemStatus 到旧版 SectionType 的映射
 * 用于兼容旧代码
 * @deprecated 请使用 MergeItemStatus
 */
export const STATUS_TO_SECTION_TYPE = {
    [MergeItemStatus.CONFLICT_UNRESOLVED]: 'unresolved',
    [MergeItemStatus.CONFLICT_RESOLVED]: 'resolved',
    [MergeItemStatus.AUTO_MERGED]: 'merged',
};
// ============================================================================
// 冲突解决类型枚举
// ============================================================================
/**
 * 冲突接受类型
 * 用于标识用户选择保留哪个版本的代码
 */
export var AcceptType;
(function (AcceptType) {
    /** 保留当前分支版本 */
    AcceptType[AcceptType["CURRENT"] = 0] = "CURRENT";
    /** 保留合并分支版本 */
    AcceptType[AcceptType["INCOMING"] = 1] = "INCOMING";
    /** 保留两个版本 */
    AcceptType[AcceptType["BOTH"] = 2] = "BOTH";
})(AcceptType || (AcceptType = {}));
// ============================================================================
// 冲突标记正则表达式
// ============================================================================
/**
 * 冲突标记正则表达式
 * 用于匹配 Git 风格的冲突标记
 */
export const CONFLICT_MARKER_REGEX = '(<<<<<<<)[\\s\\S\\n]*?(=======)[\\s\\S\\n]*?(>>>>>>>)';
/**
 * 冲突分隔符
 */
export const CONFLICT_SPLITTER = '=======';
// ============================================================================
// 侧边栏配置
// ============================================================================
/**
 * 侧边栏区域配置
 */
export const SIDEBAR_SECTIONS = [
    {
        status: MergeItemStatus.CONFLICT_UNRESOLVED,
        title: '冲突未解决',
        color: 'red',
    },
    {
        status: MergeItemStatus.CONFLICT_RESOLVED,
        title: '冲突已解决',
        color: 'orange',
    },
    {
        status: MergeItemStatus.AUTO_MERGED,
        title: '代码已合并',
        color: 'green',
    },
];
/**
 * 侧边栏默认宽度（像素）
 */
export const SIDEBAR_DEFAULT_WIDTH = 300;
/**
 * 侧边栏最小宽度（像素）
 */
export const SIDEBAR_MIN_WIDTH = 150;
/**
 * 侧边栏最大宽度（像素）
 */
export const SIDEBAR_MAX_WIDTH = 600;
/**
 * 侧边栏 LocalStorage 键名
 */
export const SIDEBAR_STORAGE_KEY = 'MergeModalSidebar';
